<template>
<div class="chapter">
<div class="inner_page">
<p class="dedt"><a id="page_4"></a>Dedication</p>
<p class="ded">To those who believed I could do this.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication.vue?5df563cf